// import React, { useState } from 'react';
// import { TextField, Button, Typography, Container, Box, FormControlLabel, Checkbox, FormGroup } from '@mui/material';
// import api from '../api';

// const CreateRole = () => {
//   // State for storing form data and response messages
//   const [roleName, setRoleName] = useState('');
//   const [selectedPermissions, setSelectedPermissions] = useState({});
//   const [message, setMessage] = useState('');
//   const [error, setError] = useState('');

//   // Sample permission data with parent-child relationships
//   const permissionsData = [
//     {
//       label: 'Company',
//       nodeId: 'company',
//       subPermissions: [
//         { label: 'Create Company', nodeId: 'create-company' },
//         { label: 'Edit Company', nodeId: 'edit-company' },
//       ],
//     },
//     {
//       label: 'Employee',
//       nodeId: 'employee',
//       subPermissions: [
//         { label: 'Create Employee', nodeId: 'create-employee' },
//         { label: 'Edit Employee', nodeId: 'edit-employee' },
//       ],
//     },
//     {
//       label: 'Product',
//       nodeId: 'product',
//       subPermissions: [
//         { label: 'Create Product', nodeId: 'create-product' },
//         { label: 'Edit Product', nodeId: 'edit-product' },
//       ],
//     },
//   ];

//   // Handle input changes for role name
//   const handleRoleNameChange = (e) => setRoleName(e.target.value);

//   // Handle parent checkbox change
//   const handleParentCheckboxChange = (event) => {
//     const { value, checked } = event.target;

//     setSelectedPermissions((prev) => {
//       const updatedPermissions = { ...prev };
//       updatedPermissions[value] = checked;
      
//       // If the parent is unchecked, uncheck all its sub-permissions
//       if (!checked && updatedPermissions[value]) {
//         permissionsData
//           .find((permission) => permission.nodeId === value)
//           ?.subPermissions.forEach((sub) => {
//             updatedPermissions[sub.nodeId] = false;
//           });
//       }
//       return updatedPermissions;
//     });
//   };

//   // Handle sub-checkbox change (when user selects/unselects a sub-permission)
//   const handleSubCheckboxChange = (event) => {
//     const { value, checked } = event.target;
//     setSelectedPermissions((prev) => ({
//       ...prev,
//       [value]: checked,
//     }));
//   };

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Prepare data for the API request
//     const roleData = {
//       roleName,
//       permissions: Object.keys(selectedPermissions).filter(
//         (key) => selectedPermissions[key]
//       ), // Send only the selected permissions
//     };

//     try {
//       const response = await api.post('/api/roles/', roleData); // Replace with your API endpoint

//       // Clear previous errors and show success message
//       setError('');
//       setMessage('Role created successfully!');
//       console.log(response.data); // Optionally log the response
//     } catch (err) {
//       // If error, set error message
//       setMessage('');
//       setError('Error creating role. Please try again.');
//     }
//   };

//   return (
//     <Container maxWidth="sm">
//       <Box sx={{ textAlign: 'center', mt: 3 }}>
//         <Typography variant="h4" gutterBottom>
//           Create New Role
//         </Typography>
//         <form onSubmit={handleSubmit}>
//           {/* Role Name Input */}
//           <TextField
//             label="Role Name"
//             variant="outlined"
//             fullWidth
//             required
//             value={roleName}
//             onChange={handleRoleNameChange}
//             sx={{ mb: 2 }}
//           />

//           {/* Permissions Selection using Checkboxes */}
//           <FormGroup>
//             {permissionsData.map((permission) => (
//               <div key={permission.nodeId}>
//                 {/* Parent Checkbox */}
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       value={permission.nodeId}
//                       checked={selectedPermissions[permission.nodeId] || false}
//                       onChange={handleParentCheckboxChange}
//                     />
//                   }
//                   label={permission.label}
//                 />

//                 {/* Sub-Permissions (displayed when parent is checked) */}
//                 {selectedPermissions[permission.nodeId] && permission.subPermissions.map((subPermission) => (
//                   <FormControlLabel
//                     key={subPermission.nodeId}
//                     control={
//                       <Checkbox
//                         value={subPermission.nodeId}
//                         checked={selectedPermissions[subPermission.nodeId] || false}
//                         onChange={handleSubCheckboxChange}
//                       />
//                     }
//                     label={subPermission.label}
//                   />
//                 ))}
//               </div>
//             ))}
//           </FormGroup>

//           {/* Submit Button */}
//           <Button variant="contained" type="submit" fullWidth sx={{ mt: 3 }}>
//             Create Role
//           </Button>
//         </form>

//         {/* Display success or error messages */}
//         {message && <Typography color="green" sx={{ mt: 2 }}>{message}</Typography>}
//         {error && <Typography color="red" sx={{ mt: 2 }}>{error}</Typography>}
//       </Box>
//     </Container>
//   );
// };

// export default CreateRole;


import React, { useState } from 'react';
import api from '../api';
import { TextField, Button, Typography, Container, Box, FormControlLabel, Checkbox, FormGroup } from '@mui/material';
import { fetchUserId, fetchCompanyId } from '../helpers/CompanyId';
// import { Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';

const CreateRole = () => {
  // State for storing form data and response messages
  const [roleName, setRoleName] = useState('');
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Sample permission data
  const permissionsData = [
    { nodeId: 'c-role', label: 'Create Role' },
    { nodeId: 'c-admin', label: 'Create Admin' },
    { nodeId: 'c-accountmanager', label: 'Create Account Manager' },
    { nodeId: 'c-regemployee', label: 'Register Employees' },
    { nodeId: 'c-company', label: 'Create Company' },
    { nodeId: 'u-company', label: 'Update Company' },
    { nodeId: 'd-company', label: 'Delete Company' },
    { nodeId: 'v-company', label: 'View Company' },
    { nodeId: 'c-payroll', label: 'Create Payroll Setup' },
    { nodeId: 'u-payroll', label: 'Update Payroll Setup' },
    { nodeId: 'v-payroll', label: 'View Payroll Setup' },
    { nodeId: 'd-payroll', label: 'Delete Payroll Setup' },
    { nodeId: 'c-employee', label: 'Create Employee' },
    { nodeId: 'u-employee', label: 'Update Employee' },
    { nodeId: 'v-employeelist', label: 'View Employee List' },
    { nodeId: 'd-employee', label: 'Delete Employee' },
    { nodeId: 'v-employee', label: 'View Employee' },
    { nodeId: 'up-attendance', label: 'Upload Attendance' },
    { nodeId: 'up-biometric', label: 'Upload Biometric Attendance' },
    { nodeId: 'v-validation', label: 'View Payroll Data' },
    { nodeId: 'c-payslip', label: 'View and Generate Payslip' },
    { nodeId: 'v-payslip', label: 'Generate Payslip by employee' },

  ];

  // Handle input changes
  const handleRoleNameChange = (e) => setRoleName(e.target.value);

  // Handle permissions selection changes
  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setSelectedPermissions((prev) => [...prev, value]);
    } else {
      setSelectedPermissions((prev) => prev.filter((item) => item !== value));
    }
  };

  // Handle form submission
  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   const userId = await fetchUserId();
  //   if (!userId) {
  //     setError("User ID not found");
  //     return;
  //   }

  //   const companyId = await fetchCompanyId(userId);
  //   if (!companyId) {
  //     setError("Company ID not found");
  //     return;
  //   }

    
  //   // Prepare data for the API request
  //   const roleData = {
  //     roleName,
  //     permissions: selectedPermissions, // Send selected permission IDs
  //   };

  //   // Append companyId to formData
  //   const updateroleData = { ...roleData, company: companyId };

  //   try {
  //     const response = await api.post('/api/roles/', updateroleData); // Replace with your API endpoint

  //     // Clear previous errors and show success message
  //     setError('');
  //     setMessage('Role created successfully!');
  //     console.log(response.data); // Optionally log the response
  //     navigate('/home');

  //   } catch (err) {
  //     // If error, set error message
  //     setMessage('');
  //     setError('Error creating role. Please try again.');
  //   }
  // };

  // Handle form submission
const handleSubmit = async (e) => {
  e.preventDefault();

  const userId = await fetchUserId();
  if (!userId) {
    setError("User ID not found");
    return;
  }

  // Attempt to fetch companyId
  const companyId = await fetchCompanyId(userId);

  // Prepare data for the API request
  const roleData = {
    roleName,
    permissions: selectedPermissions, // Send selected permission IDs
  };

  // Conditionally append companyId if found
  if (companyId) {
    roleData.company = companyId;
  }

  try {
    const response = await api.post('/api/roles/', roleData); // Replace with your API endpoint

    // Clear previous errors and show success message
    setError('');
    setMessage('Role created successfully!');
    console.log(response.data); // Optionally log the response
    navigate('/home1');
  } catch (err) {
    // If error, set error message
    setMessage('');
    setError('Error creating role. Please try again.');
  }
};


  return (
    <div>
      <Navbar />
    <Container maxWidth="sm">
      <Box sx={{ textAlign: 'center', mt: 3 }}>
        <Typography variant="h6" gutterBottom>
          Create New Role
        </Typography>
        <form onSubmit={handleSubmit}>
          {/* Role Name Input */}
          <TextField
            label="Role Name"
            variant="outlined"
            fullWidth
            required
            value={roleName}
            onChange={handleRoleNameChange}
            sx={{ mb: 2 }}
          />

          {/* Permissions Selection using Checkboxes */}
          <FormGroup>
            {permissionsData.map((permission) => (
              <FormControlLabel
                key={permission.nodeId}
                control={
                  <Checkbox
                    value={permission.nodeId}
                    checked={selectedPermissions.includes(permission.nodeId)}
                    onChange={handleCheckboxChange}
                  />
                }
                label={permission.label}
              />
            ))}
          </FormGroup>

          {/* Submit Button */}
          <Button variant="contained" type="submit" fullWidth sx={{ mt: 3 }}>
            Create Role
          </Button>
        </form>

        {/* Display success or error messages */}
        {message && <Typography color="green" sx={{ mt: 2 }}>{message}</Typography>}
        {error && <Typography color="red" sx={{ mt: 2 }}>{error}</Typography>}
      </Box>
    </Container>
    </div>
  );
};

export default CreateRole;
